import { render, staticRenderFns } from "./ScaniaNextGenGeneralWarningSymbols.vue?vue&type=template&id=c9a85c90&"
import script from "./ScaniaNextGenGeneralWarningSymbols.vue?vue&type=script&lang=js&"
export * from "./ScaniaNextGenGeneralWarningSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports